import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "sticky top-0 z-40 flex h-16 items-center justify-between border-b border-gray-200 bg-white px-6 shadow-sm rounded-b-2xl" }
const _hoisted_2 = { class: "hidden md:flex items-center gap-4 cursor-not-allowed" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FontAwesomeIcon = _resolveComponent("FontAwesomeIcon")!

  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _cache[1] || (_cache[1] = _createElementVNode("h1", { class: "text-lg mdtext-xl font-semibold text-gray-900 select-none" }, " Dashboard ", -1)),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_FontAwesomeIcon, { icon: _ctx.faBell }, null, 8, ["icon"])
    ]),
    _createElementVNode("button", {
      class: "md:hidden p-2 rounded-lg hover:bg-gray-100",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('toggleSidebar')))
    }, [
      _createVNode(_component_FontAwesomeIcon, { icon: _ctx.faBars }, null, 8, ["icon"])
    ])
  ]))
}